import React from 'react';
import { Tooltip } from 'fw/components';

class CheckBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = { value: props.value };
	}

	// Public API
	setValue = (value) => {
		this._update(value);
	}

	getValue = () => {
		return this.state.value;
	}

	// Events
	onDirt = (e) => {
		this.props.onDirt && this.props.onDirt();
	}

	onChange = (value) => {
		this.props.onChange && this.props.onChange(value);
	}

	// Private
	_update = (value) => {
		const me = this;

		this.setState({ value }, function () {
			me.onDirt();

			// If managed by forms, trigger field change, then change
			if (this.props.managed)
				this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
			else
				// If not, only trigger this comp change
				this.onChange(value);
		});
	}

	_handleChange = (e) => {
		this._update(e.target.checked);
	}

	// React lifecycle events
	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value) {
			this.setState({ value: nextProps.value });
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.value !== this.props.value
			|| nextState.value !== this.state.value
			|| nextProps.disabled !== this.props.disabled);
	}

	render() {
		let className = "checkbox";

		if (this.props.inline)
			className = "checkbox-inline"

		const props = {
			name: this.props.name,
			type: "checkbox",
			checked: this.state.value,
			disabled: this.props.disabled ? "disabled" : undefined,
			onChange: this._handleChange
		};

		return (
			<div className={className} style={this.props.style}>
				<label>
					<input {...props} ref={(input) => { this._input = input; }} />
					<div dangerouslySetInnerHTML={{ __html: this.props.label }} />
				</label>
				{ this.props.tip && <Tooltip tip={this.props.tip}/> }
			</div>)
	}
}

export default CheckBox;

CheckBox.defaultProps = {
	formControl: true,
	managed: false
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/checkBox/CheckBox.js